'use strict';
var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor)
                descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function (Constructor, protoProps, staticProps) {
        if (protoProps)
            defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
            defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
require('./DPlayer.scss');
var _utils = require('./utils');
var _utils2 = _interopRequireDefault(_utils);
var _svg = require('./svg');
var _svg2 = _interopRequireDefault(_svg);
var _option = require('./option');
var _option2 = _interopRequireDefault(_option);
var _i18n = require('./i18n');
var _i18n2 = _interopRequireDefault(_i18n);
var _html = require('./html');
var _html2 = _interopRequireDefault(_html);
var _danmaku = require('./danmaku');
var _danmaku2 = _interopRequireDefault(_danmaku);
var _thumbnails = require('./thumbnails');
var _thumbnails2 = _interopRequireDefault(_thumbnails);
var _events = require('./events');
var _events2 = _interopRequireDefault(_events);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
var index = 0;
var DPlayer = function () {
    function DPlayer(option) {
        var _this = this;
        _classCallCheck(this, DPlayer);
        this.option = (0, _option2.default)(option);
        this.option.element.classList.add('dplayer');
        if (this.option.video.quality) {
            this.qualityIndex = this.option.video.defaultQuality;
            this.quality = this.option.video.quality[this.option.video.defaultQuality];
        }
        this.tran = new _i18n2.default(this.option.lang).tran;
        this.events = new _events2.default();
        this.element = this.option.element;
        if (!this.option.danmaku) {
            this.element.classList.add('dplayer-no-danmaku');
        }
        if (_utils.isMobile) {
            this.element.classList.add('dplayer-mobile');
        }
        this.element.innerHTML = _html2.default.main(option, index, this.tran);
        var bar = {};
        bar.volumeBar = this.element.getElementsByClassName('dplayer-volume-bar-inner')[0];
        bar.playedBar = this.element.getElementsByClassName('dplayer-played')[0];
        bar.loadedBar = this.element.getElementsByClassName('dplayer-loaded')[0];
        var pbar = this.element.getElementsByClassName('dplayer-bar-wrap')[0];
        var pbarTimeTips = this.element.getElementsByClassName('dplayer-bar-time')[0];
        var barWidth = void 0;
        this.updateBar = function (type, percentage, direction) {
            percentage = percentage > 0 ? percentage : 0;
            percentage = percentage < 1 ? percentage : 1;
            bar[type + 'Bar'].style[direction] = percentage * 100 + '%';
        };
        document.addEventListener('click', function () {
            _this.focus = false;
        }, true);
        this.element.addEventListener('click', function () {
            _this.focus = true;
        }, true);
        if (this.option.danmaku) {
            this.danmaku = new _danmaku2.default({
                container: this.element.getElementsByClassName('dplayer-danmaku')[0],
                opacity: localStorage.getItem('danmaku-opacity') || 0.7,
                callback: function callback() {
                    _this.element.getElementsByClassName('dplayer-danloading')[0].style.display = 'none';
                    if (_this.option.autoplay && !_utils.isMobile) {
                        _this.play();
                    } else if (_utils.isMobile) {
                        _this.pause();
                    }
                },
                error: function error(msg) {
                    _this.notice(msg);
                },
                apiBackend: this.option.apiBackend,
                borderColor: this.option.theme,
                height: this.arrow ? 24 : 30,
                time: function time() {
                    return _this.video.currentTime;
                },
                unlimited: this.option.danmaku.unlimited,
                api: {
                    id: this.option.danmaku.id,
                    address: this.option.danmaku.api,
                    token: this.option.danmaku.token,
                    maximum: this.option.danmaku.maximum,
                    addition: this.option.danmaku.addition,
                    user: this.option.danmaku.user
                },
                events: this.events
            });
        }
        this.arrow = this.element.offsetWidth <= 500;
        if (this.arrow) {
            var arrowStyle = document.createElement('style');
            arrowStyle.innerHTML = '.dplayer .dplayer-danmaku{font-size:18px}';
            document.head.appendChild(arrowStyle);
        }
        this.video = this.element.getElementsByClassName('dplayer-video-current')[0];
        this.bezel = this.element.getElementsByClassName('dplayer-bezel-icon')[0];
        this.bezel.addEventListener('animationend', function () {
            _this.bezel.classList.remove('dplayer-bezel-transition');
        });
        this.playButton = this.element.getElementsByClassName('dplayer-play-icon')[0];
        this.paused = true;
        this.playButton.addEventListener('click', function () {
            _this.toggle();
        });
        var videoWrap = this.element.getElementsByClassName('dplayer-video-wrap')[0];
        var conMask = this.element.getElementsByClassName('dplayer-controller-mask')[0];
        if (!_utils.isMobile) {
            videoWrap.addEventListener('click', function () {
                _this.toggle();
            });
            conMask.addEventListener('click', function () {
                _this.toggle();
            });
        } else {
            var toggleController = function toggleController() {
                if (_this.element.classList.contains('dplayer-hide-controller')) {
                    _this.element.classList.remove('dplayer-hide-controller');
                } else {
                    _this.element.classList.add('dplayer-hide-controller');
                }
            };
            videoWrap.addEventListener('click', toggleController);
            conMask.addEventListener('click', toggleController);
        }
        var lastPlayPos = 0;
        var currentPlayPos = 0;
        var bufferingDetected = false;
        window.requestAnimationFrame = function () {
            return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
                window.setTimeout(callback, 1000 / 60);
            };
        }();
        var setCheckLoadingTime = function setCheckLoadingTime() {
            _this.checkLoading = setInterval(function () {
                currentPlayPos = _this.video.currentTime;
                if (!bufferingDetected && currentPlayPos < lastPlayPos + 0.01 && !_this.video.paused) {
                    _this.element.classList.add('dplayer-loading');
                    bufferingDetected = true;
                }
                if (bufferingDetected && currentPlayPos > lastPlayPos + 0.01 && !_this.video.paused) {
                    _this.element.classList.remove('dplayer-loading');
                    bufferingDetected = false;
                }
                lastPlayPos = currentPlayPos;
            }, 100);
        };
        var clearCheckLoadingTime = function clearCheckLoadingTime() {
            clearInterval(_this.checkLoading);
        };
        this.playedTime = false;
        this.animationFrame = function () {
            if (_this.playedTime) {
                _this.updateBar('played', _this.video.currentTime / _this.video.duration, 'width');
                _this.element.getElementsByClassName('dplayer-ptime')[0].innerHTML = _utils2.default.secondToTime(_this.video.currentTime);
            }
            window.requestAnimationFrame(_this.animationFrame);
        };
        window.requestAnimationFrame(this.animationFrame);
        this.setTime = function (type) {
            if (!type) {
                _this.playedTime = true;
                setCheckLoadingTime();
            } else {
                _this[type + 'Time'] = true;
                if (type === 'played') {
                    setCheckLoadingTime();
                }
            }
        };
        this.clearTime = function (type) {
            if (!type) {
                _this.playedTime = false;
                clearCheckLoadingTime();
            } else {
                _this[type + 'Time'] = false;
                if (type === 'played') {
                    clearCheckLoadingTime();
                }
            }
        };
        pbar.addEventListener('click', function (event) {
            var e = event || window.event;
            barWidth = pbar.clientWidth;
            var percentage = (e.clientX - _utils2.default.getElementViewLeft(pbar)) / barWidth;
            percentage = percentage > 0 ? percentage : 0;
            percentage = percentage < 1 ? percentage : 1;
            _this.updateBar('played', percentage, 'width');
            _this.seek(parseFloat(bar.playedBar.style.width) / 100 * _this.video.duration);
        });
        if (this.option.video.thumbnails) {
            this.initThumbnails();
        }
        this.isTimeTipsShow = true;
        this.mouseHandler = this.mouseHandler(pbar, pbarTimeTips).bind(this);
        pbar.addEventListener('mousemove', this.mouseHandler);
        pbar.addEventListener('mouseenter', this.mouseHandler);
        pbar.addEventListener('mouseleave', this.mouseHandler);
        var thumbMove = function thumbMove(event) {
            var e = event || window.event;
            var percentage = (e.clientX - _utils2.default.getElementViewLeft(pbar)) / barWidth;
            percentage = percentage > 0 ? percentage : 0;
            percentage = percentage < 1 ? percentage : 1;
            _this.updateBar('played', percentage, 'width');
            _this.element.getElementsByClassName('dplayer-ptime')[0].innerHTML = _utils2.default.secondToTime(percentage * _this.video.duration);
        };
        var thumbUp = function thumbUp() {
            document.removeEventListener('mouseup', thumbUp);
            document.removeEventListener('mousemove', thumbMove);
            _this.seek(parseFloat(bar.playedBar.style.width) / 100 * _this.video.duration);
            _this.setTime();
        };
        pbar.addEventListener('mousedown', function () {
            barWidth = pbar.clientWidth;
            _this.clearTime();
            document.addEventListener('mousemove', thumbMove);
            document.addEventListener('mouseup', thumbUp);
        });
        var volumeEle = this.element.getElementsByClassName('dplayer-volume')[0];
        var volumeBarWrapWrap = this.element.getElementsByClassName('dplayer-volume-bar-wrap')[0];
        var volumeBarWrap = this.element.getElementsByClassName('dplayer-volume-bar')[0];
        var volumeicon = this.element.getElementsByClassName('dplayer-volume-icon')[0];
        var vWidth = 35;
        this.switchVolumeIcon = function () {
            var volumeicon = _this.element.getElementsByClassName('dplayer-volume-icon')[0];
            if (_this.volume() >= 0.95) {
                volumeicon.innerHTML = (0, _svg2.default)('volume-up');
            } else if (_this.volume() > 0) {
                volumeicon.innerHTML = (0, _svg2.default)('volume-down');
            } else {
                volumeicon.innerHTML = (0, _svg2.default)('volume-off');
            }
        };
        var volumeMove = function volumeMove(event) {
            var e = event || window.event;
            var percentage = (e.clientX - _utils2.default.getElementViewLeft(volumeBarWrap) - 5.5) / vWidth;
            _this.volume(percentage);
        };
        var volumeUp = function volumeUp() {
            document.removeEventListener('mouseup', volumeUp);
            document.removeEventListener('mousemove', volumeMove);
            volumeEle.classList.remove('dplayer-volume-active');
        };
        volumeBarWrapWrap.addEventListener('click', function (event) {
            var e = event || window.event;
            var percentage = (e.clientX - _utils2.default.getElementViewLeft(volumeBarWrap) - 5.5) / vWidth;
            _this.volume(percentage);
        });
        volumeBarWrapWrap.addEventListener('mousedown', function () {
            document.addEventListener('mousemove', volumeMove);
            document.addEventListener('mouseup', volumeUp);
            volumeEle.classList.add('dplayer-volume-active');
        });
        volumeicon.addEventListener('click', function () {
            if (_this.video.muted) {
                _this.video.muted = false;
                _this.switchVolumeIcon();
                _this.updateBar('volume', _this.volume(), 'width');
            } else {
                _this.video.muted = true;
                volumeicon.innerHTML = (0, _svg2.default)('volume-off');
                _this.updateBar('volume', 0, 'width');
            }
        });
        this.hideTime = 0;
        var hideController = function hideController() {
            _this.element.classList.remove('dplayer-hide-controller');
            clearTimeout(_this.hideTime);
            _this.hideTime = setTimeout(function () {
                if (_this.video.played.length) {
                    _this.element.classList.add('dplayer-hide-controller');
                    closeSetting();
                    closeComment();
                }
            }, 2000);
        };
        if (!_utils.isMobile) {
            this.element.addEventListener('mousemove', hideController);
            this.element.addEventListener('click', hideController);
        }
        var settingHTML = _html2.default.setting(this.tran);
        var settingIcon = this.element.getElementsByClassName('dplayer-setting-icon')[0];
        var settingBox = this.element.getElementsByClassName('dplayer-setting-box')[0];
        var mask = this.element.getElementsByClassName('dplayer-mask')[0];
        settingBox.innerHTML = settingHTML.original;
        var closeSetting = function closeSetting() {
            if (settingBox.classList.contains('dplayer-setting-box-open')) {
                settingBox.classList.remove('dplayer-setting-box-open');
                mask.classList.remove('dplayer-mask-show');
                setTimeout(function () {
                    settingBox.classList.remove('dplayer-setting-box-narrow');
                    settingBox.innerHTML = settingHTML.original;
                    settingEvent();
                }, 300);
            }
        };
        var openSetting = function openSetting() {
            settingBox.classList.add('dplayer-setting-box-open');
            mask.classList.add('dplayer-mask-show');
        };
        mask.addEventListener('click', function () {
            closeSetting();
        });
        settingIcon.addEventListener('click', function () {
            openSetting();
        });
        this.loop = this.option.loop;
        var showdan = true;
        var settingEvent = function settingEvent() {
            var loopEle = _this.element.getElementsByClassName('dplayer-setting-loop')[0];
            var loopToggle = loopEle.getElementsByClassName('dplayer-toggle-setting-input')[0];
            loopToggle.checked = _this.loop;
            loopEle.addEventListener('click', function () {
                loopToggle.checked = !loopToggle.checked;
                if (loopToggle.checked) {
                    _this.loop = true;
                } else {
                    _this.loop = false;
                }
                closeSetting();
            });
            var showDanEle = _this.element.getElementsByClassName('dplayer-setting-showdan')[0];
            var showDanToggle = showDanEle.getElementsByClassName('dplayer-showdan-setting-input')[0];
            showDanToggle.checked = showdan;
            showDanEle.addEventListener('click', function () {
                showDanToggle.checked = !showDanToggle.checked;
                if (showDanToggle.checked) {
                    showdan = true;
                    if (!_this.paused) {
                        _this.danmaku.show();
                    }
                } else {
                    showdan = false;
                    _this.danmaku.hide();
                }
                closeSetting();
            });
            var speedEle = _this.element.getElementsByClassName('dplayer-setting-speed')[0];
            speedEle.addEventListener('click', function () {
                settingBox.classList.add('dplayer-setting-box-narrow');
                settingBox.innerHTML = settingHTML.speed;
                var speedItem = settingBox.getElementsByClassName('dplayer-setting-speed-item');
                var _loop = function _loop(i) {
                    speedItem[i].addEventListener('click', function () {
                        _this.video.playbackRate = speedItem[i].dataset.speed;
                        closeSetting();
                    });
                };
                for (var i = 0; i < speedItem.length; i++) {
                    _loop(i);
                }
            });
            if (_this.danmaku) {
                bar.danmakuBar = _this.element.getElementsByClassName('dplayer-danmaku-bar-inner')[0];
                var danmakuBarWrapWrap = _this.element.getElementsByClassName('dplayer-danmaku-bar-wrap')[0];
                var danmakuBarWrap = _this.element.getElementsByClassName('dplayer-danmaku-bar')[0];
                var danmakuSettingBox = _this.element.getElementsByClassName('dplayer-setting-danmaku')[0];
                var dWidth = 130;
                _this.updateBar('danmaku', _this.danmaku.opacity(), 'width');
                var danmakuMove = function danmakuMove(event) {
                    var e = event || window.event;
                    var percentage = (e.clientX - _utils2.default.getElementViewLeft(danmakuBarWrap)) / dWidth;
                    percentage = percentage > 0 ? percentage : 0;
                    percentage = percentage < 1 ? percentage : 1;
                    _this.updateBar('danmaku', percentage, 'width');
                    _this.danmaku.opacity(percentage);
                };
                var danmakuUp = function danmakuUp() {
                    document.removeEventListener('mouseup', danmakuUp);
                    document.removeEventListener('mousemove', danmakuMove);
                    danmakuSettingBox.classList.remove('dplayer-setting-danmaku-active');
                };
                danmakuBarWrapWrap.addEventListener('click', function (event) {
                    var e = event || window.event;
                    var percentage = (e.clientX - _utils2.default.getElementViewLeft(danmakuBarWrap)) / dWidth;
                    percentage = percentage > 0 ? percentage : 0;
                    percentage = percentage < 1 ? percentage : 1;
                    _this.updateBar('danmaku', percentage, 'width');
                    _this.danmaku.opacity(percentage);
                });
                danmakuBarWrapWrap.addEventListener('mousedown', function () {
                    document.addEventListener('mousemove', danmakuMove);
                    document.addEventListener('mouseup', danmakuUp);
                    danmakuSettingBox.classList.add('dplayer-setting-danmaku-active');
                });
            }
        };
        settingEvent();
        if (this.video.duration !== 1) {
            this.element.getElementsByClassName('dplayer-dtime')[0].innerHTML = this.video.duration ? _utils2.default.secondToTime(this.video.duration) : '00:00';
        }
        if (!this.danmaku) {
            if (this.option.autoplay && !_utils.isMobile) {
                this.play();
            } else if (_utils.isMobile) {
                this.pause();
            }
        }
        var commentInput = this.element.getElementsByClassName('dplayer-comment-input')[0];
        var commentIcon = this.element.getElementsByClassName('dplayer-comment-icon')[0];
        var commentBox = this.element.getElementsByClassName('dplayer-comment-box')[0];
        var commentSettingIcon = this.element.getElementsByClassName('dplayer-comment-setting-icon')[0];
        var commentSettingBox = this.element.getElementsByClassName('dplayer-comment-setting-box')[0];
        var commentSendIcon = this.element.getElementsByClassName('dplayer-send-icon')[0];
        var closeCommentSetting = function closeCommentSetting() {
            if (commentSettingBox.classList.contains('dplayer-comment-setting-open')) {
                commentSettingBox.classList.remove('dplayer-comment-setting-open');
            }
        };
        var toggleCommentSetting = function toggleCommentSetting() {
            if (commentSettingBox.classList.contains('dplayer-comment-setting-open')) {
                commentSettingBox.classList.remove('dplayer-comment-setting-open');
            } else {
                commentSettingBox.classList.add('dplayer-comment-setting-open');
            }
        };
        var disableHide = 0;
        var commentFocusTimeout = 0;
        var closeComment = function closeComment() {
            if (!commentBox.classList.contains('dplayer-comment-box-open')) {
                return;
            }
            commentBox.classList.remove('dplayer-comment-box-open');
            mask.classList.remove('dplayer-mask-show');
            _this.element.classList.remove('dplayer-show-controller');
            clearInterval(disableHide);
            clearTimeout(commentFocusTimeout);
            closeCommentSetting();
        };
        var openComment = function openComment() {
            if (commentBox.classList.contains('dplayer-comment-box-open')) {
                return;
            }
            commentBox.classList.add('dplayer-comment-box-open');
            mask.classList.add('dplayer-mask-show');
            _this.element.classList.add('dplayer-show-controller');
            disableHide = setInterval(function () {
                clearTimeout(_this.hideTime);
            }, 1000);
            commentFocusTimeout = setTimeout(function () {
                commentInput.focus();
            }, 300);
        };
        mask.addEventListener('click', function () {
            closeComment();
        });
        commentIcon.addEventListener('click', function () {
            openComment();
        });
        commentSettingIcon.addEventListener('click', function () {
            toggleCommentSetting();
        });
        this.element.getElementsByClassName('dplayer-comment-setting-color')[0].addEventListener('click', function () {
            var sele = _this.element.querySelector('input[name="dplayer-danmaku-color-${index}"]:checked+span');
            if (sele) {
                commentSettingIcon.getElementsByClassName('dplayer-fill')[0].style.fill = _this.element.querySelector('input[name="dplayer-danmaku-color-${index}"]:checked').value;
            }
        });
        var sendComment = function sendComment() {
            commentInput.blur();
            if (!commentInput.value.replace(/^\s+|\s+$/g, '')) {
                _this.notice(_this.tran('Please input danmaku content!'));
                return;
            }
            _this.danmaku.send({
                text: commentInput.value,
                color: _this.element.querySelector('.dplayer-comment-setting-color input:checked').value,
                type: _this.element.querySelector('.dplayer-comment-setting-type input:checked').value
            }, function () {
                commentInput.value = '';
                closeComment();
            });
        };
        commentInput.addEventListener('click', function () {
            closeCommentSetting();
        });
        commentInput.addEventListener('keydown', function (e) {
            var event = e || window.event;
            if (event.keyCode === 13) {
                sendComment();
            }
        });
        commentSendIcon.addEventListener('click', sendComment);
        this.element.addEventListener('fullscreenchange', function () {
            _this.resize();
        });
        this.element.addEventListener('mozfullscreenchange', function () {
            _this.resize();
        });
        this.element.addEventListener('webkitfullscreenchange', function () {
            _this.resize();
        });
        this.element.getElementsByClassName('dplayer-full-icon')[0].addEventListener('click', function () {
            if (!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement) {
                if (_this.element.requestFullscreen) {
                    _this.element.requestFullscreen();
                } else if (_this.element.mozRequestFullScreen) {
                    _this.element.mozRequestFullScreen();
                } else if (_this.element.webkitRequestFullscreen) {
                    _this.element.webkitRequestFullscreen();
                } else if (_this.video.webkitEnterFullscreen) {
                    _this.video.webkitEnterFullscreen();
                }
                _this.events.trigger('fullscreen');
            } else {
                if (document.cancelFullScreen) {
                    document.cancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                }
                _this.events.trigger('fullscreen_cancel');
            }
            _this.resize();
        });
        this.element.getElementsByClassName('dplayer-full-in-icon')[0].addEventListener('click', function () {
            if (_this.element.classList.contains('dplayer-fulled')) {
                _this.element.classList.remove('dplayer-fulled');
            } else {
                _this.element.classList.add('dplayer-fulled');
                _this.resize();
            }
        });
        var handleKeyDown = function handleKeyDown(e) {
            if (_this.focus) {
                var tag = document.activeElement.tagName.toUpperCase();
                var editable = document.activeElement.getAttribute('contenteditable');
                if (tag !== 'INPUT' && tag !== 'TEXTAREA' && editable !== '' && editable !== 'true') {
                    var event = e || window.event;
                    var percentage = void 0;
                    switch (event.keyCode) {
                    case 32:
                        event.preventDefault();
                        _this.toggle();
                        break;
                    case 37:
                        event.preventDefault();
                        _this.seek(_this.video.currentTime - 5);
                        hideController();
                        break;
                    case 39:
                        event.preventDefault();
                        _this.seek(_this.video.currentTime + 5);
                        hideController();
                        break;
                    case 38:
                        event.preventDefault();
                        percentage = _this.volume() + 0.1;
                        _this.volume(percentage);
                        break;
                    case 40:
                        event.preventDefault();
                        percentage = _this.volume() - 0.1;
                        _this.volume(percentage);
                        break;
                    }
                }
            }
        };
        if (this.option.hotkey) {
            document.addEventListener('keydown', handleKeyDown);
        }
        document.addEventListener('keydown', function (e) {
            var event = e || window.event;
            switch (event.keyCode) {
            case 27:
                if (_this.element.classList.contains('dplayer-fulled')) {
                    _this.element.classList.remove('dplayer-fulled');
                    _this.resize();
                }
                break;
            }
        });
        var menu = this.element.getElementsByClassName('dplayer-menu')[0];
        this.element.addEventListener('contextmenu', function (e) {
            var event = e || window.event;
            event.preventDefault();
            menu.classList.add('dplayer-menu-show');
            var clientRect = _this.element.getBoundingClientRect();
            var menuLeft = event.clientX - clientRect.left;
            var menuTop = event.clientY - clientRect.top;
            if (menuLeft + menu.offsetWidth >= clientRect.width) {
                menu.style.right = clientRect.width - menuLeft + 'px';
                menu.style.left = 'initial';
            } else {
                menu.style.left = event.clientX - _this.element.getBoundingClientRect().left + 'px';
                menu.style.right = 'initial';
            }
            if (menuTop + menu.offsetHeight >= clientRect.height) {
                menu.style.bottom = clientRect.height - menuTop + 'px';
                menu.style.top = 'initial';
            } else {
                menu.style.top = event.clientY - _this.element.getBoundingClientRect().top + 'px';
                menu.style.bottom = 'initial';
            }
            mask.classList.add('dplayer-mask-show');
            _this.events.trigger('contextmenu_show');
            mask.addEventListener('click', function () {
                mask.classList.remove('dplayer-mask-show');
                menu.classList.remove('dplayer-menu-show');
                _this.events.trigger('contextmenu_hide');
            });
        });
        if (this.option.video.quality) {
            this.element.getElementsByClassName('dplayer-quality-list')[0].addEventListener('click', function (e) {
                if (e.target.classList.contains('dplayer-quality-item')) {
                    _this.switchQuality(e.target.dataset.index);
                }
            });
        }
        if (this.option.screenshot) {
            var camareIcon = this.element.getElementsByClassName('dplayer-camera-icon')[0];
            camareIcon.addEventListener('click', function () {
                var canvas = document.createElement('canvas');
                canvas.width = _this.video.videoWidth;
                canvas.height = _this.video.videoHeight;
                canvas.getContext('2d').drawImage(_this.video, 0, 0, canvas.width, canvas.height);
                var dataURL = canvas.toDataURL();
                camareIcon.href = dataURL;
                camareIcon.download = 'DPlayer.png';
                _this.events.trigger('screenshot', dataURL);
            });
        }
        this.initVideo(this.video, this.quality && this.quality.type || this.option.video.type);
        index++;
    }
    _createClass(DPlayer, [
        {
            key: 'seek',
            value: function seek(time) {
                time = Math.max(time, 0);
                if (this.video.duration) {
                    time = Math.min(time, this.video.duration);
                }
                if (this.video.currentTime < time) {
                    this.notice(this.tran('FF to') + ' ' + _utils2.default.secondToTime(time));
                } else if (this.video.currentTime > time) {
                    this.notice(this.tran('REW to') + ' ' + _utils2.default.secondToTime(time));
                }
                this.video.currentTime = time;
                if (this.danmaku) {
                    this.danmaku.seek();
                }
                this.updateBar('played', time / this.video.duration, 'width');
            }
        },
        {
            key: 'play',
            value: function play() {
                this.paused = false;
                if (this.video.paused) {
                    this.bezel.innerHTML = (0, _svg2.default)('play');
                    this.bezel.classList.add('dplayer-bezel-transition');
                }
                this.playButton.innerHTML = (0, _svg2.default)('pause');
                this.video.play();
                this.setTime();
                this.element.classList.add('dplayer-playing');
                if (this.danmaku) {
                    this.danmaku.play();
                }
            }
        },
        {
            key: 'pause',
            value: function pause() {
                this.paused = true;
                this.element.classList.remove('dplayer-loading');
                if (!this.video.paused) {
                    this.bezel.innerHTML = (0, _svg2.default)('pause');
                    this.bezel.classList.add('dplayer-bezel-transition');
                }
                this.ended = false;
                this.playButton.innerHTML = (0, _svg2.default)('play');
                this.video.pause();
                this.clearTime();
                this.element.classList.remove('dplayer-playing');
                if (this.danmaku) {
                    this.danmaku.pause();
                }
            }
        },
        {
            key: 'volume',
            value: function volume(percentage, nonotice, nostorage) {
                percentage = parseFloat(percentage);
                if (!isNaN(percentage)) {
                    percentage = percentage > 0 ? percentage : 0;
                    percentage = percentage < 1 ? percentage : 1;
                    this.updateBar('volume', percentage, 'width');
                    if (!nostorage) {
                        localStorage.setItem('dplayer-volume', percentage);
                    }
                    if (!nonotice) {
                        this.notice(this.tran('Volume') + ' ' + (percentage * 100).toFixed(0) + '%');
                    }
                    this.video.volume = percentage;
                    if (this.video.muted) {
                        this.video.muted = false;
                    }
                    this.switchVolumeIcon();
                }
                return this.video.volume;
            }
        },
        {
            key: 'toggle',
            value: function toggle() {
                if (this.video.paused) {
                    this.play();
                } else {
                    this.pause();
                }
            }
        },
        {
            key: 'on',
            value: function on(name, callback) {
                this.events.on(name, callback);
            }
        },
        {
            key: 'switchVideo',
            value: function switchVideo(video, danmakuAPI) {
                this.pause();
                this.video.poster = video.pic ? video.pic : '';
                this.video.src = video.url;
                this.initMSE(this.video, video.type || 'auto');
                if (danmakuAPI) {
                    this.element.getElementsByClassName('dplayer-danloading')[0].style.display = 'block';
                    this.updateBar('played', 0, 'width');
                    this.updateBar('loaded', 0, 'width');
                    this.element.getElementsByClassName('dplayer-ptime')[0].innerHTML = '00:00';
                    this.element.getElementsByClassName('dplayer-danmaku')[0].innerHTML = '';
                    if (this.danmaku) {
                        this.danmaku.reload({
                            id: danmakuAPI.id,
                            address: danmakuAPI.api,
                            token: danmakuAPI.token,
                            maximum: danmakuAPI.maximum,
                            addition: danmakuAPI.addition,
                            user: danmakuAPI.user
                        });
                    }
                }
            }
        },
        {
            key: 'initMSE',
            value: function initMSE(video, type) {
                this.type = type;
                if (this.type === 'auto') {
                    if (/m3u8(#|\?|$)/i.exec(video.src)) {
                        this.type = 'hls';
                    } else if (/.flv(#|\?|$)/i.exec(video.src)) {
                        this.type = 'flv';
                    } else {
                        this.type = 'normal';
                    }
                }
                if (this.type === 'hls' && Hls.isSupported()) {
                    var hls = new Hls();
                    hls.loadSource(video.src);
                    hls.attachMedia(video);
                }
                if (this.type === 'flv' && flvjs.isSupported()) {
                    var flvPlayer = flvjs.createPlayer({
                        type: 'flv',
                        url: video.src
                    });
                    flvPlayer.attachMediaElement(video);
                    flvPlayer.load();
                }
            }
        },
        {
            key: 'initVideo',
            value: function initVideo(video, type) {
                var _this2 = this;
                this.initMSE(video, type);
                this.on('durationchange', function () {
                    if (video.duration !== 1) {
                        _this2.element.getElementsByClassName('dplayer-dtime')[0].innerHTML = _utils2.default.secondToTime(video.duration);
                    }
                });
                this.on('progress', function () {
                    var percentage = video.buffered.length ? video.buffered.end(video.buffered.length - 1) / video.duration : 0;
                    _this2.updateBar('loaded', percentage, 'width');
                });
                this.on('error', function () {
                    _this2.tran && _this2.notice && _this2.notice(_this2.tran('This video fails to load'), -1);
                });
                this.ended = false;
                this.on('ended', function () {
                    _this2.updateBar('played', 1, 'width');
                    if (!_this2.loop) {
                        _this2.ended = true;
                        _this2.pause();
                    } else {
                        _this2.seek(0);
                        video.play();
                    }
                    if (_this2.danmaku) {
                        _this2.danmaku.danIndex = 0;
                    }
                });
                this.on('play', function () {
                    if (_this2.paused) {
                        _this2.play();
                    }
                });
                this.on('pause', function () {
                    if (!_this2.paused) {
                        _this2.pause();
                    }
                });
                var _loop2 = function _loop2(i) {
                    video.addEventListener(_this2.events.videoEvents[i], function () {
                        _this2.events.trigger(_this2.events.videoEvents[i]);
                    });
                };
                for (var i = 0; i < this.events.videoEvents.length; i++) {
                    _loop2(i);
                }
                this.volume(localStorage.getItem('dplayer-volume') || this.option.volume, true, true);
            }
        },
        {
            key: 'switchQuality',
            value: function switchQuality(index) {
                var _this3 = this;
                if (this.qualityIndex === index || this.switchingQuality) {
                    return;
                } else {
                    this.qualityIndex = index;
                }
                this.switchingQuality = true;
                this.quality = this.option.video.quality[index];
                this.element.getElementsByClassName('dplayer-quality-icon')[0].innerHTML = this.quality.name;
                var paused = this.video.paused;
                this.video.pause();
                var videoHTML = _html2.default.video(false, null, this.option.screenshot, 'auto', this.quality.url);
                var videoEle = new DOMParser().parseFromString(videoHTML, 'text/html').body.firstChild;
                var parent = this.element.getElementsByClassName('dplayer-video-wrap')[0];
                parent.insertBefore(videoEle, parent.getElementsByTagName('div')[0]);
                this.prevVideo = this.video;
                this.video = videoEle;
                this.initVideo(this.video, this.quality.type || this.option.video.type);
                this.seek(this.prevVideo.currentTime);
                this.notice(this.tran('Switching to') + ' ' + this.quality.name + ' ' + this.tran('quality'), -1);
                this.events.trigger('quality_start', this.quality);
                this.on('canplay', function () {
                    if (_this3.prevVideo) {
                        if (_this3.video.currentTime !== _this3.prevVideo.currentTime) {
                            _this3.seek(_this3.prevVideo.currentTime);
                            return;
                        }
                        parent.removeChild(_this3.prevVideo);
                        _this3.video.classList.add('dplayer-video-current');
                        if (!paused) {
                            _this3.video.play();
                        }
                        _this3.prevVideo = null;
                        _this3.notice(_this3.tran('Switched to') + ' ' + _this3.quality.name + ' ' + _this3.tran('quality'));
                        _this3.switchingQuality = false;
                        _this3.events.trigger('quality_end');
                    }
                });
            }
        },
        {
            key: 'mouseHandler',
            value: function mouseHandler(pbar, timeTips) {
                var _this4 = this;
                var cumulativeOffset = function cumulativeOffset(element) {
                    var top = 0, left = 0;
                    do {
                        top += element.offsetTop || 0;
                        left += element.offsetLeft || 0;
                        element = element.offsetParent;
                    } while (element);
                    return {
                        top: top,
                        left: left
                    };
                };
                return function (e) {
                    if (!_this4.video.duration) {
                        return;
                    }
                    var clientX = e.clientX;
                    var px = cumulativeOffset(pbar).left;
                    var tx = clientX - px;
                    if (tx < 0 || tx > pbar.offsetWidth) {
                        return;
                    }
                    var time = _this4.video.duration * (tx / pbar.offsetWidth);
                    timeTips.style.left = tx - 20 + 'px';
                    switch (e.type) {
                    case 'mouseenter':
                        _this4.thumbnails && _this4.thumbnails.show();
                        break;
                    case 'mousemove':
                        _this4.thumbnails && _this4.thumbnails.move(tx);
                        timeTips.innerText = _utils2.default.secondToTime(time);
                        _this4.timeTipsDisplay(true, timeTips);
                        break;
                    case 'mouseleave':
                        _this4.thumbnails && _this4.thumbnails.hide();
                        _this4.timeTipsDisplay(false, timeTips);
                        break;
                    }
                };
            }
        },
        {
            key: 'timeTipsDisplay',
            value: function timeTipsDisplay(show, timeTips) {
                if (show) {
                    if (this.isTimeTipsShow) {
                        return;
                    }
                    timeTips.classList.remove('hidden');
                    this.isTimeTipsShow = true;
                } else {
                    if (!this.isTimeTipsShow) {
                        return;
                    }
                    timeTips.classList.add('hidden');
                    this.isTimeTipsShow = false;
                }
            }
        },
        {
            key: 'initThumbnails',
            value: function initThumbnails() {
                var _this5 = this;
                this.thumbnails = new _thumbnails2.default(this.element.getElementsByClassName('dplayer-bar-preview')[0], this.element.getElementsByClassName('dplayer-bar-wrap')[0].offsetWidth, this.option.video.thumbnails, this.events);
                this.on('loadedmetadata', function () {
                    _this5.thumbnails.resize(160, 90);
                });
            }
        },
        {
            key: 'notice',
            value: function notice(text) {
                var _this6 = this;
                var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2000;
                var opacity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.8;
                var noticeEle = this.element.getElementsByClassName('dplayer-notice')[0];
                noticeEle.innerHTML = text;
                noticeEle.style.opacity = opacity;
                if (this.noticeTime) {
                    clearTimeout(this.noticeTime);
                }
                this.events.trigger('notice_show', text);
                this.noticeTime = setTimeout(function () {
                    noticeEle.style.opacity = 0;
                    _this6.events.trigger('notice_hide');
                }, time);
            }
        },
        {
            key: 'resize',
            value: function resize() {
                if (this.danmaku) {
                    this.danmaku.resize();
                }
                this.events.trigger('resize');
            }
        },
        {
            key: 'destroy',
            value: function destroy() {
                this.pause();
                clearTimeout(this.hideTime);
                this.video.src = '';
                this.element.innerHTML = '';
                this.events.trigger('destroy');
                for (var key in this) {
                    if (this.hasOwnProperty(key) && key !== 'paused') {
                        delete this[key];
                    }
                }
            }
        }
    ]);
    return DPlayer;
}();
module.exports = DPlayer;


//////////////////
// WEBPACK FOOTER
// ./src/DPlayer.js
// module id = 2
// module chunks = 0